// Import model
import { FilterIndividualContactRequest } from '../models/FilterIndividualContactRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { IndividualContactCondition } from '../models/IndividualContactCondition';
import { IndividualContactFields } from '../models/IndividualContactFields';
import { IndividualContactIndexedFields } from '../models/IndividualContactIndexedFields';

// Import dependency serializers (for complex types)
import { IndividualContactConditionSerializer } from './IndividualContactConditionSerializer';
import { IndividualContactFieldsSerializer } from './IndividualContactFieldsSerializer';
import { IndividualContactIndexedFieldsSerializer } from './IndividualContactIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterIndividualContactRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterIndividualContactRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterIndividualContactRequest instance
   */
  static deserialize(json: string): FilterIndividualContactRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterIndividualContactRequest instance
   */
  static fromObject(obj: any): FilterIndividualContactRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterIndividualContactRequest');
    }


    const instance: FilterIndividualContactRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as IndividualContactIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as IndividualContactFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        IndividualContactConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterIndividualContactRequest instances
   */
  static deserializeArray(json: string): FilterIndividualContactRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterIndividualContactRequest instance to a JSON string
   */
  static serialize(instance: FilterIndividualContactRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterIndividualContactRequest instance to a plain object
   */
  static toObject(instance: FilterIndividualContactRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        IndividualContactConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterIndividualContactRequest instances to a JSON string
   */
  static serializeArray(instances: FilterIndividualContactRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
